// @packages
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CtrlTabPanel from '../controls/toolkit/ctrl-tab-panel';
// @scripts
import CtrlIgGrid, { exportScheduleGridToExcel, importExcel } from '../controls/toolkit/ctrl-ig-grid';
import Toolbar from './toolbar';
import columns from './columns';
import { config } from '../../config';
import { environment, globalUI } from '../../core';
import { newGuid } from '../../helpers';

// @styles
import styles from './styles';

const Schedule = ({
    id,
    onAddItemToScheduleImport,
    onRemoveItemsFromSchedule,
    onSendScheduleItemsToEdge,
    onCommitItemFromSchedule,
    scheduleItems,
    sessionId,
    classes
}) => {
    const idGrid = `${id}-grid`;
    const iData = useRef([]);
    const [tabActive, setTabActive] = useState(0);
    const [expanded, setExpanded] = useState(true);
    const handleOnCheckAllItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedAllItems, ...items]
            : checkedAllItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedAllItems(checked);
    };
    const handleOnCheckStationaryItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedStationaryItems, ...items]
            : checkedStationaryItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedStationaryItems(checked);
    };
    const handleOnCheckwinddrivenItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedwinddrivenItems, ...items]
            : checkedwinddrivenItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedwinddrivenItems(checked);
    };
    const handleOnCheckhurricaneItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedhurricaneItems, ...items]
            : checkedhurricaneItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedhurricaneItems(checked);
    };
    const handleOnCheckadjustableItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedadjustableItems, ...items]
            : checkedadjustableItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedadjustableItems(checked);
    };
    const handleOnCheckcombinationItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedcombinationItems, ...items]
            : checkedcombinationItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedcombinationItems(checked);
    };
    const handleOnCheckacousticalItemChanged = ({ items, isChecked }) => {
        const checked = isChecked
            ? [...checkedacousticalItems, ...items]
            : checkedacousticalItems.filter((checkedItem) => !items.some((item) => item === checkedItem));
            setCheckedacousticalItems(checked);
    };
   
    const idAllGrid = `${id}-AllGrid`;
    const idStationaryGrid = `${id}-StationaryGrid`;
    const idwind_drivenGrid = `${id}-wind_drivenGrid`;
    const idhurricaneGrid = `${id}-hurricaneGrid`;
    const idadjustableGrid = `${id}-adjustableGrid`;
    const idcombinationGrid = `${id}-combinationGrid`;
    const idacousticalGrid = `${id}-acousticalGrid`;
    const primaryKey = 'id';
    const [checkedAllItems, setCheckedAllItems] = useState([]);
    const [checkedStationaryItems, setCheckedStationaryItems] = useState([]);
    const [checkedwinddrivenItems, setCheckedwinddrivenItems] = useState([]);
    const [checkedhurricaneItems, setCheckedhurricaneItems] = useState([]);
    const [checkedadjustableItems, setCheckedadjustableItems] = useState([]);
    const [checkedcombinationItems, setCheckedcombinationItems] = useState([]);
    const [checkedacousticalItems, setCheckedacousticalItems] = useState([]);

    const anyCheckedItems =  (checkedAllItems.length !== 0 && tabActive === 0)
        ||(checkedStationaryItems.length !== 0 && tabActive === 1)
        || (checkedwinddrivenItems.length !== 0 && tabActive === 2)
         || (checkedhurricaneItems.length !== 0 && tabActive === 3)
         || (checkedadjustableItems.length !== 0 && tabActive === 4)
         || (checkedcombinationItems.length !== 0 && tabActive === 5)
         || (checkedacousticalItems.length !== 0 && tabActive === 6);
         

    const CATEGORY = {
        STATIONARY: 'Stationary',
        WIND_DRIVEN: 'Wind-Driven',
        HURRICANE: 'Hurricane',
        ADJUSTABLE: 'Adjustable',
        COMBINATION: 'Combination',
        ACOUSTICAL: 'Acoustical',
        ALL:'All'
    };
    const handleOnRemoveFromSchedule = () => {
        const { title, message } = config.text.deleteRowsFromScheduleConfirm;
        globalUI.showModalDialog({
            title,
            msg: message,
            onConfirm: () => {
                let checkedItems = checkedAllItems;
                if (tabActive === 1) {
                    checkedItems = checkedStationaryItems;
                } else if (tabActive === 2) {
                    checkedItems = checkedwinddrivenItems;
                } else if (tabActive === 3) {
                    checkedItems = checkedhurricaneItems;
                } else if (tabActive === 4) {
                    checkedItems = checkedadjustableItems;
                } else if (tabActive === 5) {
                    checkedItems = checkedcombinationItems;
                } else if (tabActive === 6) {
                    checkedItems = checkedacousticalItems;
                } 
                onRemoveItemsFromSchedule(checkedItems);
                if (tabActive === 0) {
                    setCheckedAllItems([]);
                } else if (tabActive === 1) {
                    setCheckedStationaryItems([]);
                } else if (tabActive === 2) {
                    setCheckedwinddrivenItems([]);
                } else if (tabActive === 3) {
                    setCheckedhurricaneItems([]);
                } else if (tabActive === 4) {
                    setCheckedadjustableItems([]);
                } else if (tabActive === 5) {
                    setCheckedcombinationItems([]);
                } else if (tabActive === 6) {
                    setCheckedacousticalItems([]);
                } 
                
            }
        });
    };

    const handleOnImportIconClicked = (buttonOffsetTop) => {
        iData.current = [];
        const importmsg = config.text.common.importmsg;
        const editForm = (
            <div>
                <div>{importmsg}</div>
                <div><input type="file" id="input" onChange={(_event) => importExcel(_event, iData)} accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                </div>
                <div id="result"></div>
            </div>
        );
        const onConfirm = () => {
            onAddItemToScheduleImport(iData.current);
        };

        globalUI.showModalDialog({
            msg: editForm,
            onConfirm,
            style: environment.isProduction && environment.isFromSelNav ? { top: buttonOffsetTop } : null,
            title: `Import Excel File`
        });
    }
    const handleOnexportToExcelClicked=()=>{
        let checkedGridID = idAllGrid;
        if (tabActive === 1) {
            checkedGridID = idStationaryGrid;
        } else if (tabActive === 2) {
            checkedGridID = idwind_drivenGrid;
        } else if (tabActive === 3) {
            checkedGridID = idhurricaneGrid;
        } else if (tabActive === 4) {
            checkedGridID = idadjustableGrid;
        } else if (tabActive === 5) {
            checkedGridID = idcombinationGrid;
        } else if (tabActive === 6) {
            checkedGridID = idacousticalGrid;
        }
        //exportToExcel({ id: checkedGridID, fileName: 'Schedule' })
    };
    const handleOnSendScheduleItemsToEdge = () => {
        let checkedItems = checkedAllItems;
        if (tabActive === 1) {
            checkedItems = checkedStationaryItems;
        } else if (tabActive === 2) {
            checkedItems = checkedwinddrivenItems;
        } else if (tabActive === 3) {
            checkedItems = checkedhurricaneItems;
        } else if (tabActive === 4) {
            checkedItems = checkedadjustableItems;
        } else if (tabActive === 5) {
            checkedItems = checkedcombinationItems;
        } else if (tabActive === 6) {
            checkedItems = checkedacousticalItems;
        } 
        const items = anyCheckedItems ? checkedItems : scheduleItems;
        onSendScheduleItemsToEdge(items);
    };
    const getGridData = (category) => {
        debugger;
        let gridData = null;
        if (category === CATEGORY.STATIONARY) {
            gridData = scheduleItems.filter((s) => s.styleDescription === CATEGORY.STATIONARY);
        } else if (category === CATEGORY.WIND_DRIVEN) {
            gridData = scheduleItems.filter((s) => s.styleDescription === CATEGORY.WIND_DRIVEN);
        } else if (category === CATEGORY.HURRICANE) {
            gridData = scheduleItems.filter((s) => s.styleDescription === CATEGORY.HURRICANE);
        } else if (category === CATEGORY.ADJUSTABLE) {
            gridData = scheduleItems.filter((s) => s.styleDescription === CATEGORY.ADJUSTABLE);
        } else if (category === CATEGORY.COMBINATION) {
            gridData = scheduleItems.filter((s) => s.styleDescription === CATEGORY.COMBINATION);
        } else if (category === CATEGORY.ACOUSTICAL) {
            gridData = scheduleItems.filter((s) => s.styleDescription === CATEGORY.ACOUSTICAL);
        } else {
            gridData = scheduleItems;
        }
        return gridData;
    };
    const handleChangeTabs = (e, newValue) => {
        setTabActive(newValue);
        //getAllCacheData(setValue);
    };
    return (
        <Grid id={id} container>
            <Grid item xs={12}>
                <Toolbar
                    options={[{
                        icon: 'fa-file-excel-o',
                        onClick: () => exportScheduleGridToExcel({
                            allId: idAllGrid,
                            sid:idStationaryGrid,
                            wid:idwind_drivenGrid,
                            hid:idhurricaneGrid,
                            adjid:idadjustableGrid,
                            comid:idcombinationGrid,
                            acoid:idacousticalGrid,
                            fileName: 'Schedule',
                            accessoryArray: '0'
                        }),
                        title: config.text.common.exportToExcel
                    }, {
                        disabled: !anyCheckedItems,
                        icon: 'fa-trash',
                        onClick: handleOnRemoveFromSchedule,
                        title: config.text.common.delete
                    }, {
                        icon: 'fa-download',
                        onClick: handleOnImportIconClicked,
                        title: config.text.common.import
                    }, {
                        disabled: scheduleItems.length === 0,
                        icon: 'fa-upload',
                        onClick: handleOnSendScheduleItemsToEdge,
                        title: config.text.common.sendToEdge,
                        visible: Boolean(sessionId)
                    }]}
                />

            </Grid>
            <Grid item xs={12} className={classes.schedulegrid}>
                    <Tabs value={tabActive} onChange={handleChangeTabs} className={classes.tabs}>
                        <Tab label="All Louvers" name="all" className={classes.tab} />
                        <Tab label="Stationary" name="Stationary" className={classes.tab} />
                        <Tab label="Wind Driven" name="wind_driven" className={classes.tab} />
                        <Tab label="Hurricane" name="hurricane" className={classes.tab} />
                        <Tab label="Adjustable" name="adjustable" className={classes.tab} />
                        <Tab label="Combination" name="combination" className={classes.tab} />
                        <Tab label="Acoustical" name="acoustical" className={classes.tab} />

                    </Tabs>
                    <CtrlTabPanel value={tabActive} index={0}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedAllItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.ALL)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idAllGrid}
                                onCheckItemChanged={handleOnCheckAllItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
                    <CtrlTabPanel value={tabActive} index={1}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedStationaryItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.STATIONARY)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idStationaryGrid}
                                onCheckItemChanged={handleOnCheckStationaryItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
                    <CtrlTabPanel value={tabActive} index={2}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedwinddrivenItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.WIND_DRIVEN)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idwind_drivenGrid}
                                onCheckItemChanged={handleOnCheckwinddrivenItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
                    <CtrlTabPanel value={tabActive} index={3}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedhurricaneItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.HURRICANE)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idhurricaneGrid}
                                onCheckItemChanged={handleOnCheckhurricaneItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
                    <CtrlTabPanel value={tabActive} index={4}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedadjustableItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.ADJUSTABLE)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idadjustableGrid}
                                onCheckItemChanged={handleOnCheckadjustableItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
                    <CtrlTabPanel value={tabActive} index={5}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedcombinationItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.COMBINATION)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idcombinationGrid}
                                onCheckItemChanged={handleOnCheckcombinationItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
                    <CtrlTabPanel value={tabActive} index={6}>
                        <div>
                            <CtrlIgGrid
                                className={classes.iggrid}
                                checkedItems={checkedacousticalItems}
                                columns={columns}
                                dataSource={getGridData(CATEGORY.ACOUSTICAL)}
                                enableHotkeys
                                enableCheckBox
                                enableFilter
                                enableHiding
                                enableMoveColumn
                                enablePaging
                                enableResize
                                enableUpdate
                                enableSort
                                fixedHeaders
                                headerLabels={config.text.schedulePage.headerLabels}
                                height="550"
                                id={idacousticalGrid}
                                onCheckItemChanged={handleOnCheckacousticalItemChanged}
                                onEditCellEnded={onCommitItemFromSchedule}
                                primaryKey={primaryKey}
                            />
                            <div className={classes.accessorySpacing} />
                        </div>
                    </CtrlTabPanel>
            </Grid>
        </Grid>
    );
};

Schedule.propTypes = {
    id: PropTypes.string.isRequired,
    onRemoveItemsFromSchedule: PropTypes.func.isRequired,
    onSendScheduleItemsToEdge: PropTypes.func.isRequired,
    onCommitItemFromSchedule: PropTypes.func.isRequired,
    scheduleItems: PropTypes.array.isRequired,
    sessionId: PropTypes.string
};

Schedule.defaultProps = {
    sessionId: null
};

export default withStyles(styles)(Schedule);
